import React, { Component } from "react";
import styles from "./controlPointInfo.module.scss";
import { withRoutes } from "../../shared/containers/containerRoutes";
import { withCreateControlPoints } from "../../shared/containers/containerCreateControlPoint";
import { withControlPoints } from "../../shared/containers/containerControlPoints";
import ModalConfirmWindow from "../Contents/ModalComponents/ModalConfirmWindow";
import DeleteConfirm from "../Contents/ModalComponents/DeleteConfirm";

class ControlPointInfo extends Component {
  constructor(props) {
    super(props);

    this.state = { title: "", isOpenDeleteConfirm: false };
  }

  componentDidUpdate(prevProps) {
    const { createControlPoint } = this.props;

    if (prevProps.createControlPoint === null && createControlPoint !== null) {
      this.setState({ title: createControlPoint.title });
    }

    if (prevProps.createControlPoint !== null && createControlPoint !== null) {
      if (prevProps.createControlPoint.id !== createControlPoint.id) {
        this.setState({ title: createControlPoint.title });
      }
    }
  }

  onCancelHandler() {
    const { onClearCreateControlPoint } = this.props;
    onClearCreateControlPoint();
  }

  handleEditTitle(e) {
    this.setState({ title: e.target.value });
  }

  onCreate() {
    const { onCreateControlPoint, createControlPoint } = this.props;
    const { title } = this.state;

    createControlPoint.title = title;
    createControlPoint.address = "Без адреса"
    onCreateControlPoint(createControlPoint);
  }

  onDeleteConfirm() {
    const { onDeleteControlPoint, createControlPoint } = this.props;
    onDeleteControlPoint(createControlPoint);
    this.setState({ isOpenDeleteConfirm: false });
  }

  onHandleDeleteClick(e) {
    e.stopPropagation();
    this.setState({ isOpenDeleteConfirm: true });
  }

  onNotDeleteConfirm(e) {
    e.stopPropagation();
    this.setState({ isOpenDeleteConfirm: false });
  }

  render() {
    const { selectedRouteId, createControlPoint } = this.props;

    if (selectedRouteId !== null || createControlPoint === null) {
      return null;
    }

    const { title, isOpenDeleteConfirm } = this.state;

    return (
      <div className={styles.controlPointInfoContainer}>
        <div>
          <div className={styles.titleContainer}>
            <div>Наименование</div>
            <input disabled={createControlPoint.id !== null} value={title ?? ""} onChange={this.handleEditTitle.bind(this)} />
          </div>
          <div className={styles.titleContainer}>Радиус фиксирования брибытия: {createControlPoint.radius} м.</div>

          <div className={styles.buttonsContainer}>
            <div>
              {createControlPoint.id !== null ? (
                createControlPoint.routes.length === 0 ? (
                  <button
                    onClick={(e) => {
                      this.onHandleDeleteClick(e);
                    }}
                  >
                    Удалить
                  </button>
                ) : null
              ) : (
                <button onClick={this.onCreate.bind(this)}>Сохранить</button>
              )}
            </div>

            <ModalConfirmWindow isOpen={isOpenDeleteConfirm}>
              <DeleteConfirm
                onConfirmHandle={this.onDeleteConfirm.bind(this)}
                onNotConfirmHandle={this.onNotDeleteConfirm.bind(this)}
                text={`Удалить контрольную точку "${title ?? ""}"?`}
              />
            </ModalConfirmWindow>

            <div onClick={this.onCancelHandler.bind(this)}>
              <button>Отмена</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withControlPoints(withCreateControlPoints(withRoutes(ControlPointInfo)));
